export const ICONS = {
  drag: "drag",
} as const;

export const SLOTS = {
  actionsEnd: "actions-end",
  actionsStart: "actions-start",
};
